import { Navigate, Outlet, useLocation } from "react-router-dom";
import utils from "./utils";
import constant from "./constant";

const BusinessGuard = () => {
  const location = useLocation();
  const biz_id = utils._retrieveData(constant.SELECTED_BUSINESS_ID);

  if (location.pathname.startsWith("/account")) {
    return <Outlet />;
  }

  if (!biz_id) {
    return <Navigate to="/business-select" replace />;
  }

  return <Outlet />;
};

export default BusinessGuard;
